import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-advertise';
export var ID = 'icon-advertise';
/* eslint-disable max-len */

export var SVGAdvertise = function SVGAdvertise() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 68 65"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-5.000000, -6.000000)"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "76",
    height: "76"
  }), React.createElement("path", {
    d: "M62.99985,25.3906 C67.96985,25.3906 71.99985,29.4446 71.99985,34.4446 C71.99985,39.4446 67.96985,43.4966 62.99985,43.4966",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M31.31995,45.9912 L38.10595,69.9982 L24.40995,69.9982 L17.88195,45.8652 M15.20815,24 L6.00015,24 L6.00015,41.956 L15.20815,41.956 M62.99985,58.5 L31.31985,45.991 L18.83985,45.991 C16.71885,45.991 14.99985,44.268 14.99985,42.142 L14.99985,23.859 C14.99985,21.733 16.71885,20.01 18.83985,20.01 L31.31985,20.01 L62.99985,7.5 L62.99985,58.5 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }))));
};
/* eslint-disable max-len */

var Advertise = function Advertise(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAdvertise
  });
};

Advertise.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Advertise;